import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/settings/')({
  loader: ({ params }) =>
    redirect({
      to: '/org/$org/settings/work-integrations',
      params: { org: params.org },
    }),
});
